module.exports = __webpack_public_path__ + "static/media/S4h.c92297d9.png";